<template>
  <div v-if="showOpen">
    <div class="h5-open-app" @click="openApp">
      <img src="../assets/img/open-app.png" alt="" />
      <div v-if="isWeChat" class="open-app-btn">
        <!-- <wx-open-launch-app
          style="
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            right: 0;
            border-radius: 0.35rem;
            overflow: hidden;
          "
          id="launch-btn"
          appid="wxb509f86149696e36"
        >
          <script type="text/wxtag-template">
            <style>
              .btn-mobile {
                width: 500px;
                height: 200px;
                background: none;
                border: none;
              }
            </style>
            <button class="btn-mobile"></button>
          </script>
        </wx-open-launch-app> -->
      </div>
      <button v-else class="open-app-btn"></button>
      <i @click.stop="closeOpenApp" class="el-icon-close" />
    </div>
    <div class="seize-seat-ele"></div>
    <div class="wechat-guide" ref="guide" v-if="showGuide">
      <div class="mask" @click="showGuide = false"></div>
      <img src="../assets/img/guide.png" alt="" />
    </div>
  </div>
</template>
<script>
import wx from "@saas/components/src/mixins/wx";
import { isWeChat, isIOS } from "@saas/components/src";
const protocol = process.env.VUE_APP_DESKTOP_PROTOCAL || 'comettech://';
export default {
  mixins: [wx],
  data: function () {
    return {
      isWeChat: isWeChat(),
      iosUrl: process.env.VUE_APP_IOS_API,
      isHidden: false,
      showOpen: true,
      showGuide: false,
    };
  },
  mounted() {
    this.isIOS = isIOS();
  },
  methods: {
    openApp() {
      if (this.isWeChat) {
        this.showGuide = true;
      } else {
        if (this.isIOS) {
          window.location.href = "https://moguoyunke.com/download-app";
          // window.location.href = this.iosUrl;
        } else {
          window.location.href = protocol + "openpage";
          // setTimeout(() => {
          //   window.location.href = "/download-app";
          // }, 2000);
        }
      }
    },
    closeOpenApp() {
      this.showOpen = false;
    },
  },
  watch: {
    showOpen: {
      immediate: true, // 组件创建时立即触发
      handler(newValue) {
        if (newValue) {
          document
            .getElementsByTagName("body")[0]
            .style.setProperty("--h5-open-app-height", `1.07rem`);
        } else {
          document
            .getElementsByTagName("body")[0]
            .style.setProperty("--h5-open-app-height", `0px`);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.seize-seat-ele {
  height: 1.07rem;
}
.h5-open-app {
  position: fixed;
  width: 100%;
  top: $h5-search-height;
  height: 1.07rem;
  z-index: 100;
  img {
    width: 100%;
    height: 1.07rem;
  }
  .open-app-btn {
    position: absolute;
    right: 0.73rem;
    top: 50%;
    transform: translateY(-50%);
    width: 2rem;
    height: 0.7rem;
    border-radius: 0.35rem;
    background: transparent;
    // background: #fff;
  }
  .el-icon-close {
    position: absolute;
    color: #858687;
    font-weight: bold;
    font-size: 0.3rem;
    padding: 0.05rem;
    right: 0.25rem;
    top: 50%;
    transform: translateY(-50%);
  }
}
.wechat-guide {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  .mask {
    width: 100%;
    height: 100%;
    background: #000000;
    opacity: 0.8;
  }
  img {
    position: absolute;
    left: 50%;
    top: 1.3333rem;
    transform: translateX(-50%);
  }
}
</style>
